// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGQuestion = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#question__clip0_14307_15665)",
    children: [/*#__PURE__*/_jsx("path", {
      fillOpacity: 0.01,
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/_jsx("mask", {
      id: "question__b",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 24,
      height: 24,
      children: /*#__PURE__*/_jsx("g", {
        clipPath: "url(#question__clip1_14307_15665)",
        children: /*#__PURE__*/_jsxs("g", {
          clipPath: "url(#question__clip2_14307_15665)",
          children: [/*#__PURE__*/_jsxs("mask", {
            id: "question__a",
            style: {
              maskType: 'alpha'
            },
            maskUnits: "userSpaceOnUse",
            x: 0,
            y: 0,
            width: 24,
            height: 24,
            children: [/*#__PURE__*/_jsx("path", {
              d: "M12 17.143c.711 0 1.286.574 1.286 1.286 0 .711-.575 1.285-1.286 1.285-.711 0-1.286-.574-1.286-1.285 0-.712.575-1.286 1.286-1.286zM12.017 4.286c3.008 0 5.108 1.628 5.108 3.96 0 1.98-1.363 3.06-2.468 3.926-1.114.882-1.8 1.474-1.8 2.553 0 .472-.386.857-.857.858v.009c-.471 0-.857-.386-.857-.857 0-1.963 1.354-3.035 2.45-3.901 1.124-.891 1.818-1.491 1.818-2.588 0-1.32-1.397-2.246-3.394-2.246-1.62 0-3.077.9-3.463 2.134-.137.455-.617.703-1.072.566-.454-.137-.702-.617-.565-1.071.608-1.971 2.708-3.343 5.1-3.343z"
            }), /*#__PURE__*/_jsx("path", {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0zm0 1.714C6.326 1.714 1.714 6.326 1.714 12c0 5.674 4.612 10.286 10.286 10.286 5.674 0 10.286-4.612 10.286-10.286 0-5.674-4.612-10.286-10.286-10.286z"
            })]
          }), /*#__PURE__*/_jsx("g", {
            mask: "url(#question__a)",
            children: /*#__PURE__*/_jsx("path", {
              d: "M-1.714-1.714h27.429v27.429H-1.714z"
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#question__b)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "question__clip0_14307_15665",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "question__clip1_14307_15665",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h24v24H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "question__clip2_14307_15665",
      children: /*#__PURE__*/_jsx("path", {
        transform: "translate(-1.714 -1.714)",
        d: "M0 0h27.429v27.429H0z"
      })
    })]
  })]
}));
SVGQuestion.displayName = 'SVGQuestion';
export default SVGQuestion;